import { css } from "@emotion/react";
import { colors } from "../utils";

export const textGolf = css({ color: colors.golf });
